export enum RequestStatus {
    PENDING, READY, FINALIZED
}